import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X, Scale } from 'lucide-react'
import { useThemeColors } from '../../hooks/useThemeColors'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const colors = useThemeColors()
  
  const styles = {
  nav: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: `${colors.surface}F2`,  // 95% opacity
    backdropFilter: 'blur(8px)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    zIndex: 50
  },
  container: {
    maxWidth: '80rem',
    margin: '0 auto',
    padding: '0 1rem'
  },
  navContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 0'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: colors.primary,
    fontWeight: 'bold',
    fontSize: '1.25rem',
    textDecoration: 'none'
  },
  desktopMenu: {
    display: 'none',
    alignItems: 'center',
    gap: '2rem'
  },
  menuLink: {
    color: colors.textSecondary,
    textDecoration: 'none',
    transition: 'color 0.2s',
    cursor: 'pointer'
  },
  loginButton: {
    backgroundColor: colors.primary,
    color: colors.textInverse,
    fontWeight: '500',
    padding: '0.5rem 1.5rem',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    transition: 'background-color 0.2s'
  },
  mobileMenuButton: {
    display: 'block',
    padding: '0.5rem',
    color: colors.textSecondary,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer'
  },
  mobileMenu: {
    display: 'block',
    padding: '1rem 0',
    borderTop: '1px solid #f3f4f6'
  },
  mobileMenuContent: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '1rem'
  },
  mobileMenuLink: {
    color: colors.textSecondary,
    textDecoration: 'none',
    padding: '0.5rem 0',
    transition: 'color 0.2s'
  }
}

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        <div style={styles.navContent}>
          {/* Logo */}
          <Link to="/" style={styles.logo}>
            <Scale style={{ width: '1.5rem', height: '1.5rem' }} />
            <span>Evaloid</span>
          </Link>

          {/* Desktop Menu */}
          <div style={styles.desktopMenu}>
            <a 
              href="#features" 
              style={styles.menuLink}
              onMouseEnter={(e) => { e.currentTarget.style.color = colors.primary }}
              onMouseLeave={(e) => { e.currentTarget.style.color = colors.textSecondary }}
            >
              機能
            </a>
            <a 
              href="#pricing" 
              style={styles.menuLink}
              onMouseEnter={(e) => { e.currentTarget.style.color = colors.primary }}
              onMouseLeave={(e) => { e.currentTarget.style.color = colors.textSecondary }}
            >
              料金プラン
            </a>
            <a 
              href="#case-studies" 
              style={styles.menuLink}
              onMouseEnter={(e) => { e.currentTarget.style.color = colors.primary }}
              onMouseLeave={(e) => { e.currentTarget.style.color = colors.textSecondary }}
            >
              導入事例
            </a>
            <Link
              to="/auth"
              style={styles.loginButton}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = colors.primaryDark }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = colors.primary }}
            >
              ログイン
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={styles.mobileMenuButton}
          >
            {isMenuOpen ? <X style={{ width: '1.5rem', height: '1.5rem' }} /> : <Menu style={{ width: '1.5rem', height: '1.5rem' }} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div style={styles.mobileMenu}>
            <div style={styles.mobileMenuContent}>
              <a
                href="#features"
                style={styles.mobileMenuLink}
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#047857' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#374151' }}
              >
                機能
              </a>
              <a
                href="#pricing"
                style={styles.mobileMenuLink}
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#047857' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#374151' }}
              >
                料金プラン
              </a>
              <a
                href="#case-studies"
                style={styles.mobileMenuLink}
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#047857' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#374151' }}
              >
                導入事例
              </a>
              <Link
                to="/auth"
                style={{
                  ...styles.loginButton,
                  display: 'inline-block',
                  textAlign: 'center'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                ログイン
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* レスポンシブスタイルをメディアクエリで適用 */}
      <style>{`
        @media (min-width: 768px) {
          nav > div > div > div:nth-child(2) {
            display: flex !important;
          }
          nav > div > div > button {
            display: none !important;
          }
          nav > div > div:last-child {
            display: none !important;
          }
        }
      `}</style>
    </nav>
  )
}

export default Navbar